import { render, staticRenderFns } from "./cntPO.vue?vue&type=template&id=070a65b8&scoped=true&"
import script from "./cntPO.vue?vue&type=script&lang=js&"
export * from "./cntPO.vue?vue&type=script&lang=js&"
import style0 from "./cntPO.vue?vue&type=style&index=0&id=070a65b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070a65b8",
  null
  
)

export default component.exports
import {QChip,QAvatar,QDialog,QLayout,QHeader,QToolbar,QToolbarTitle,QTooltip,QBtn,QPageContainer,QPage,QCard,QCardSection,QMarkupTable,QInnerLoading,QSpinnerGears,ClosePopup} from 'quasar'
component.options.components = Object.assign({QChip,QAvatar,QDialog,QLayout,QHeader,QToolbar,QToolbarTitle,QTooltip,QBtn,QPageContainer,QPage,QCard,QCardSection,QMarkupTable,QInnerLoading,QSpinnerGears}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
